import { HttpInterceptorFn } from '@angular/common/http';

/** Sustituto de producción/staging de `dev-api-mocks.ts` (angular.json → fileReplacements): sin mocks. */
export const devInterceptors: HttpInterceptorFn[] = [];
